/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { StyleSheet } from 'aphrodite';
import { startCase } from 'lodash';
import { composeValidators, Checkbox, Dropdown, TextInput, isEmptyValue } from '@blend/enterprise-components';
import { inputFormatters } from '@blend/shared-react';
import { WrappedInput } from 'blb-components/WrappedInput';
import { states } from 'blb-constants/stateCodes';
export const styles = StyleSheet.create({
  fieldWrapper: {
    ':not(:last-child)': {
      marginBottom: 16
    }
  }
});
export const getNameInputConfig = type => ({
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'text'
  },
  inputComponent: TextInput,
  label: `${startCase(type)} Name`,
  labelSize: 'sm',
  name: `${type}Name`,
  validate: isEmptyValue(`${startCase(type)} name is required`)
});
export const emailInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    disabled: true,
    type: 'text'
  },
  inputComponent: TextInput,
  label: 'Email',
  labelSize: 'sm',
  name: 'username'
};
export const phoneNumberInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'phone'
  },
  inputComponent: TextInput,
  label: 'Phone Number',
  labelSize: 'sm',
  name: 'phoneNumber',
  parse: inputFormatters.PHONE.normalize,
  validate: composeValidators(val => {
    const err = val && val.length < 10 ? 'Please input a complete phone number.' : undefined;
    return err;
  }, isEmptyValue('Please input your phone number.'))
};
const typeOptions = [{
  text: 'Work',
  value: 'WORK'
}, {
  text: 'Home',
  value: 'HOME'
}, {
  text: 'Other',
  value: 'OTHER'
}];
export const typeInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    options: typeOptions,
    valueRequired: true
  },
  inputComponent: Dropdown,
  label: 'Type',
  labelSize: 'sm',
  name: 'type'
};
export const lineTextInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'text'
  },
  inputComponent: TextInput,
  label: 'Street Address',
  labelSize: 'sm',
  name: 'lineText',
  validate: isEmptyValue('Please input a street address.')
};
export const additionalLineTextInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'text'
  },
  inputComponent: TextInput,
  label: 'Apt/Unit #',
  labelSize: 'sm',
  name: 'additionalLineText'
};
export const cityInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'text'
  },
  inputComponent: TextInput,
  label: 'City',
  labelSize: 'sm',
  name: 'city',
  validate: isEmptyValue('Please enter a city.')
};
export const countyInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'text'
  },
  inputComponent: TextInput,
  label: 'County',
  labelSize: 'sm',
  name: 'county',
  validate: isEmptyValue('Please enter a county.')
};
export const stateInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: states
  },
  inputComponent: Dropdown,
  label: 'State',
  labelSize: 'sm',
  name: 'state',
  validate: isEmptyValue('Please choose a state.')
};
export const zipcodeInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    type: 'zipcode'
  },
  inputComponent: TextInput,
  label: 'Zip Code',
  labelSize: 'sm',
  name: 'zipcode',
  validate: composeValidators(val => {
    const err = val && val.length < 5 ? 'Please enter a complete zip code.' : undefined;
    return err;
  }, isEmptyValue('Please enter a zip code.'))
};

// the `checked` prop is managed internally by react-final-form
export const isDefaultAddressInputConfig = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {},
  inputComponent: Checkbox,
  label: 'Make default address',
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'isDefault',
  type: 'checkbox'
};